
export const ContractAcceptationType = {
    Signature: 1,
    Payment: 2,
    DigitalSignature: 3
} as const;

export type ContractAcceptationType = typeof ContractAcceptationType[keyof typeof ContractAcceptationType];

export const ContractAcceptationTypes: [ContractAcceptationType, string][] = [
    [ContractAcceptationType.Signature, 'Sjednání podpisem'],
    [ContractAcceptationType.Payment, 'Sjednání zaplacením'],
    [ContractAcceptationType.DigitalSignature, 'Sjednání digitálním podpisem'],
];

export const getContractAcceptationTypeName = (type: ContractAcceptationType | undefined) => {
    return type !== undefined ? ContractAcceptationTypes.find(([key]) => key === type)?.[1] : ContractAcceptationTypes.find(([key]) => key === ContractAcceptationType.Payment)?.[1];
};